import React, { Fragment } from 'react';

const RecipeCard = ({ icon, banner_color, image, url, name, rating }) => (
    <div className="c-recipe-card b-recipes-advanced-filter__grid-item">
        <a href={url?.toString()}>
            <div className="c-recipe-card__thumbnail-wrapper">
                <div className="c-recipe-card__overlay"></div>

                {/* banner_color is from the college taxonomy
                show a custom color if one exists in ACF
                */}
                <div
                    className={
                        banner_color
                            ? `e-card-badge e-card-badge--${banner_color}`
                            : `e-card-badge e-card-badge--primary`
                    }
                >
                    <div className="e-card-badge__badge-element">
                        <img
                            className="e-icon"
                            src={`/wp-content/themes/electro/img/svg/svg-white/icon-${icon}-white.svg`}
                            alt={icon}
                            height="50"
                            width="50"
                            loading="lazy"
                        />
                    </div>
                </div>

                <picture className="e-picture e-picture--4/3-ratio e-picture--rounded-none">
                    <img src={image} alt="" height="254" width="338" loading="lazy" />
                </picture>
            </div>

            <p className="h6 c-recipe-card__title">
                <span className="fancy-link" dangerouslySetInnerHTML={{ __html: name }} />
            </p>

            {!!rating && rating !== '0' && (
                <div className="e-rating c-recipe-card__rating">
                    <Fragment>
                        <img className="e-icon" src={`/wp-content/themes/electro/img/svg/full-star-dark.svg`} alt={'Star'} height="18" width="18" />
                        <span className="e-rating__rating">{Number(rating).toFixed(1)}</span>
                    </Fragment>
                </div>
            )}
        </a>
    </div>
);

export default RecipeCard;
